// ImageHoverEffects.jsx
import React from 'react';
import styled from 'styled-components';
import Mendix from '../../../assets/images/ProductSales/Mendix.png';
import NX from '../../../assets/images/ProductSales/NX.png';
import Polarion from '../../../assets/images/ProductSales/Polarion.png';
import SolidEdge from '../../../assets/images/ProductSales/solid_edge.png';
import Teamcenter from '../../../assets/images/ProductSales/teamcenter.png';
import TeamcenterX from '../../../assets/images/ProductSales/teamcenterx.png';
import opcenter from '../../../assets/images/ProductSales/Opcenter.png'

// Data Array
const boxes = [
  {
    img: Teamcenter,
    title: "Teamcenter",
    description:
      "Siemens Teamcenter is a powerful PLM solution that streamlines product development, improves collaboration, and ensures data accuracy across the entire product lifecycle. It enhances innovation and accelerates time-to-market, making it an essential tool for driving business growth and maintaining a competitive edge.",
  },
  {
    img: TeamcenterX,
    title: "TeamcenterX",
    description:
      "Teamcenter X by Siemens PLM Software is a cloud-based Product Lifecycle Management (PLM) solution that simplifies collaboration, speeds up product development, and reduces costs. It offers a scalable, secure platform with instant access to PLM capabilities, empowering teams to innovate faster and bring high-quality products to market efficiently.",
  },
  
  {
    img: NX,
    title: "NX",
    description:
      "Siemens NX, a leading CAD/CAM/CAE software by Siemens PLM, is designed for advanced product design, engineering, and manufacturing. It offers robust tools for simulation, design optimization, and automation, enhancing product development efficiency across industries.",
  },
  {
    img: opcenter,
    title: "Opcenter",
    description:
      "Opcenter is a comprehensive suite of manufacturing operations management (MOM) solutions by Siemens. It is designed to optimize productivity, enhance product quality, and improve operational efficiency by providing real-time insights, streamlining workflows, and offering integrated systems.",
  },
  {
    img: Polarion,
    title: "Polarion",
    description:
      "Polarion by Siemens is a comprehensive ALM (Application Lifecycle Management) solution that unifies software development processes, ensuring traceability, collaboration, and compliance. It accelerates project delivery, enhances quality, and reduces risk, making it ideal for complex product development environments.",
  },
  
  {
    img: Mendix,
    title: "Mendix",
    description:
      "Mendix by Siemens is a leading low-code platform that enables rapid application development, empowering businesses to innovate faster with minimal coding. It accelerates digital transformation, reduces development costs, and allows for seamless integration across systems, driving business agility and growth.",
  },
];

// Main Component
const ProductSalesServices = () => {
  return (
    <Section>
      <Header>
        <h1><span>Explore our</span> diverse range of product solutions</h1>
        <h3>Comprehensive tools tailored to your business needs.</h3>
      </Header>
      <Container>
        {boxes.map((box, index) => (
          <Box key={index}>
            <ImgBox>
              <img src={box.img} alt={box.title} />
            </ImgBox>
            <Content>
              <h2>{box.title}</h2>
              <p>{box.description}</p>
            </Content>
          </Box>
        ))}
      </Container>
    </Section>
  );
};

export default ProductSalesServices;

// Styled Components

const Section = styled.section`
  padding: 10px 40px;
  background-color: #062c3f;
  text-align: left;
  
  font-family: "Poppins", system-ui;

  @media (max-width: 576px) {
    padding: 20px 20px;
  }
`;

const Header = styled.div`
  margin-bottom: 40px;
  text-align: center;

  h1 {
    font-size: 2.5em;
    color: #fff;
    margin-bottom: 20px;
  }

  span{
  color: #00cbf1;
  }

  h3 {
    font-size: 1.2em;
    color: #ccc;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2em;
    }

    h3 {
      font-size: 1.1em;
    }
  }

  @media (max-width: 576px) {
    h1 {
      font-size: 1.8em;
      text-align: left;
      line-height: 1.71;
    }

    h3 {
      font-size: 1em;
      text-align: left;
      line-height: 1.71;
    }
  }
`;

const Container = styled.div`
  position: relative;
  width: 90%;
  max-width: 1200px;
  margin: 80px auto 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    margin: 40px auto 0;
  }

  @media (max-width: 576px) {
    margin: 20px auto 0;
  }
`;

const Box = styled.div`
  position: relative;
  width: calc(33.333% - 30px);
  margin: 15px;
  background: #000;
  box-sizing: border-box;
  overflow: hidden;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.8);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 992px) {
    width: calc(50% - 30px);
  }

  @media (max-width: 576px) {
    width: 100%;
    margin: 15px 0;
  }
`;

const ImgBox = styled.div`
  position: relative;

  img {
    width: 100%;
    transition: all 0.5s ease;
    display: block;
  }

  ${Box}:hover & img {
    opacity: 0.2;
    transform: scale(1.2);
  }
`;

const Content = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;

  h2 {
    margin: 0 0 10px;
    color: #00cbf1;
    font-weight: 600;
    transition: all 0.5s ease;
    transform: translateY(-50px);
    opacity: 0;
    visibility: hidden;
    font-size: 1.5em;
  }

  p {
    margin: 0;
    color: #fff;
    transition: all 0.5s ease;
    transform: translateY(50px);
    opacity: 0;
    text-align: left;
    hyphens: auto;
    font-weight: 300;
    line-height: 1.71;
    visibility: hidden;
    font-size: 1em;
  }

  ${Box}:hover & h2,
  ${Box}:hover & p {
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
  }

  @media (max-width: 576px) {
    padding: 15px;

    h2 {
      font-size: 1.2em;
    }

    p {
      font-size: 0.9em;
    }
  }
`;
